import { PaymentGroupService } from '@/services/payment-groups';
import { ApiReactMutationOptions } from '@/types/api';
import { PaymentPayMethod } from '@/types/payment';
import { ApiIndividualPaymentGroup } from '@/types/payment-groups';
import { useMutation } from '@tanstack/react-query';

export function useRetryPaymentGroup(
  options?: ApiReactMutationOptions<
    ApiIndividualPaymentGroup,
    { paymentGroupId: string; paymentMethod?: PaymentPayMethod }
  >,
) {
  return useMutation({
    mutationKey: [PaymentGroupService.PATH, 'retry'],
    mutationFn: ({ paymentGroupId, paymentMethod }) =>
      PaymentGroupService.retryPaymentGroup(paymentGroupId, paymentMethod),
    ...options,
  });
}
